import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TemplateVisitorCardEditComponent } from './template-visitor-card_edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [TemplateVisitorCardEditComponent],
  exports: [
    TemplateVisitorCardEditComponent
  ],
  providers: [
  ]
})
export class TemplateVisitorCardEditModule { }
